import React from 'react'
import Aside from './aside'
import MainItem from './main_item'
import { wyrm_list_5 } from '../data/wyrmprints_5.js'
import { wyrm_list_4 } from '../data/wyrmprints_4.js'
import { wyrm_list_3 } from '../data/wyrmprints_3.js'
import { wyrm_list_2 } from '../data/wyrmprints_2.js'
import zh_wyrmprints from '../locale/zh_wyrmprints'
import en_wyrmprints from '../locale/en_wyrmprints'
import ja_wyrmprints from '../locale/ja_wyrmprints'
import Options from '../locale/zh_options'
import { c_effect, effect, c_weapon, c_element } from '../data/classify'
import './main.css'

const wyrm_list = [].concat(wyrm_list_5, wyrm_list_4, wyrm_list_3, wyrm_list_2)
var main = null

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lists: [].concat(wyrm_list)
    }
    this.reset = this.reset.bind(this)
    this.searchAll = this.searchAll.bind(this)
  }

  componentDidMount() {
    main = document.getElementsByClassName('main')[0]
  }

  render() {
    const isEn = this.props.locale.match(/.*en.*/i)
    return (
      <div>
        <div className='main'>
        {
          this.state.lists.map(item => <MainItem key={item.id} value={item} isEn={isEn}/>)
        }
        </div>
        <Aside active={this.props.aside.active}
          handleClose={this.props.aside.handleClose}
          handleSubmit={this.searchAll}
          locale={this.props.locale}
        />
      </div>
    )
  }

  searchAll(data) {
    let result
    result = this.searchRarity(data.rarity)
    result = this.searchName(data.name, result)
    result = this.searchType(data.type, result)
    result = this.searchAbilities(data, result)
    main.scrollTop = 0
    this.setState({lists: result})
  }

  searchRarity(rarity) {
    switch(rarity) {
      case 'all':
      default:
        return [].concat(wyrm_list)
      case 'r5':
        return [].concat(wyrm_list_5)
      case 'r4':
        return [].concat(wyrm_list_4)
      case 'r3':
        return [].concat(wyrm_list_3)
      case 'r2':
        return [].concat(wyrm_list_2)
    }
  }

  searchName(name, array) {
    if (name === '') {
      return array
    }
    let result = []
    let regex = new RegExp('.*' + name + '.*', 'i')
    for (let index = 0; index < array.length; index++) {
      const item = array[index]
      let temp = [item.id, zh_wyrmprints[item.id], en_wyrmprints[item.id], ja_wyrmprints[item.id]]
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].toString().match(regex)) {
          result.push(item)
          break
        }
      }
    }
    return result
  }

  searchAbilities(data, array) {
    if (data.effect === 'all' && data.condition === 'all' && data.exclusive === 'all') {
      return array
    }

    let result = []
    for (let i = 0; i < array.length; i++) {
      const item = array[i]
      for (let j = 0; j < item.abilities.length; j++) {
        if(!this.searchExclusive(data, item.abilities[j]))
          continue
        if(!this.searchCondition(data, item.abilities[j]))
          continue
        if(!this.searchEffect(data, item.abilities[j]))
          continue

        result.push(item)
        break
      }
    }

    return result
  }

  searchExclusive(data, ability) {
    if (data.exclusive === 'all') {
      return true
    } if (data.exclusive === 'c_weapon' && c_weapon.includes(ability.exclusive)) {
      return true
    } else if (data.exclusive === 'c_element' && c_element.includes(ability.exclusive)) {
      return true
    } else if (ability.exclusive === data.exclusive) {
      return true
    }
    return false
  }

  searchCondition(data, ability) {
    if (data.condition === 'all') {
      return true
    } else if (effect[ability.effect].includes(data.condition)) {
      return true
    }
    return false
  }

  searchEffect(data, ability) {
    if (data.effect === 'all') {
      return true
    } else if (data.effect.substr(0, 2) === 'c_') {
      for (let i = 0; i < c_effect[data.effect].length; i++) {
        if (effect[ability.effect].includes(c_effect[data.effect][i]))
          return true
      }
    } else if (effect[ability.effect].includes(data.effect)) {
      return true
    }
    return false
  }

  searchType(type, array) {
    if (type === 'all') {
      return array 
    }

    let index = 0
    for (let i = 0; i < Options.type.length; i++) {
      if (type === Options.type[i].key) {
        index = i - 1
        break
      }
    }

    let temp = []
    for (let i = 0; i < array.length; i++) {
      if (array[i].type === index) {
        temp.push(array[i])
      }
    }
    return temp
  }

  reset() {
    this.setState({lists: wyrm_list})
  }
}

export default Main